import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function fetchContent() {
  const { data } = await api.get("/content");
  return data.clinic;
}

export async function sendInquiry(payload) {
  const { data } = await api.post("/email/send", payload);
  return data;
}

// SSE chat stream — calls onDelta(text), onInquirySent(data), onInquiryFailed(data), onDone({session_id})
export async function streamChat({ session_id, message, language, onDelta, onDone, onError, onInquirySent, onInquiryFailed }) {
  const resp = await fetch(`${API}/chat/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id, message, language }),
  });
  if (!resp.ok || !resp.body) {
    onError && onError(new Error(`HTTP ${resp.status}`));
    return;
  }
  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const part of parts) {
      const line = part.split("\n").find((l) => l.startsWith("data: "));
      if (!line) continue;
      try {
        const data = JSON.parse(line.slice(6));
        if (data.type === "delta") onDelta && onDelta(data.content);
        else if (data.type === "done") onDone && onDone(data);
        else if (data.type === "error") onError && onError(new Error(data.message));
        else if (data.type === "inquiry_sent") onInquirySent && onInquirySent(data);
        else if (data.type === "inquiry_failed") onInquiryFailed && onInquiryFailed(data);
      } catch (_e) {
        // ignore malformed SSE line
      }
    }
  }
}
